<template>
  <div
    :class="[
      'fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50',
      'overflow-hidden bg-black bg-opacity-50',
      'flex flex-col items-center justify-center space-y-2',
    ]"
  >
    <img
      style="width: 3rem;"
      class="animate-spin"
      src="@/assets/default/images/loading.png"
      alt="loading"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LoadingLayer',
});
</script>
